import api from './api';

export interface Ticket {
  ticketID: number;
  titel: string;
  was: string;
  wie?: string;
  wann?: string;
  status: string;
  prioritaet?: string;
  erstelltAm: string;
  geaendertAm: string;
  erledigtAm?: string;
  milestoneID?: number;

  // Automation fields
  autoExecute: boolean;
  executedAt?: string;
  executionResult?: string;
}

export const ticketService = {
  // Get all tickets
  async getAll(): Promise<Ticket[]> {
    try {
      const response = await api.get<Ticket[]>('/tickets');
      return response.data;
    } catch (error) {
      console.error('Fehler beim Laden der Tickets:', error);
      return [];
    }
  },

  // Get tickets assigned to a project
  async getByProject(projectId: number): Promise<Ticket[]> {
    try {
      const response = await api.get<Ticket[]>(`/projects/${projectId}/tickets`);
      return response.data;
    } catch (error) {
      console.error('Fehler beim Laden der zugeordneten Tickets:', error);
      return [];
    }
  },
};
